import ActionTypes from '../actionTypes';

const touchAllSections = () => ({
  type: ActionTypes.TOUCH_ALL_SECTIONS,
});

export default touchAllSections;
